import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import { ISOTAccessabilty } from '../../services';
import { NumberPad } from "../../directives/numberPad/numberPad.component";

/** Konfiguration für den NumberPadDialog */
export interface NumberPadDialogComponentConfig {
  /** Barrierefreiheitseinstellungen */
  accessabilty: ISOTAccessabilty;
  /** Länge der Nummer die Abgefragt wird */
  numberlength: number;
}

/** Dialog mit einem Nummernblock, der für die Eingabe von Zahlen genutzt werden kann, z.B. für die Pagereingabe */
@Component({
  selector: "sot-numberpaddialog",
  templateUrl: "./numberpaddialog.component.html",
  styleUrls: ["./numberpaddialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberPadDialogComponent {
  @ViewChild("numberPad") numberPad: NumberPad;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<NumberPadDialogComponent, string>
    , @Inject(MAT_DIALOG_DATA) private _config: NumberPadDialogComponentConfig
    , private _coreLogService: CoreLogService) { }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }

  /** Länge der Nummer die Abgefragt wird */
  public get numberlength(): number {
    return this._config.numberlength;
  }

  /** Barrierefreiheitseinstellung ModeOne aktiv */
  public get isModeOne(): boolean {
    return this._config.accessabilty.useModeOne;
  }

  /** Barrierefreiheitseinstellung ModeTwo aktiv */
  public get isModeTwo(): boolean {
    return this._config.accessabilty.useModeTwo;
  }

  /** Hinterlegte Nummer in der Oberfläche */
  public get numberString(): string {
    const me = this;
    return me.numberPad.numberPadResult;
  }

  /** Gibt an ob der Submit Button deaktiviert ist */
  public get submitDisabled(): boolean {
    const me = this;
    return me.numberPad.submitDisabled;
  }

  /** Schliest den dialog mit der eingegebenen Nummer als Rückgabewert, wenn die Eingabe gültig ist, ansonsten wird die Eingabe als ungültig markiert */
  public submit(): void {
    const me = this;
    if (!me.submitDisabled) {
      me.dialogRef.close(me.numberString);
    } else {
      me.numberPad.toggleInputValid();
    }
    me.PushChanges();
  }

  /** Bricht die Eingabe ab und schliesst damit den Dialog */
  public cancel(): void {
    const me = this;
    me.dialogRef.close();
  }

  /** Aktualisiert die Oberfläche, muss nach einer Änderung, die die UI betrifft, aufgerufen werden */
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("NumberPadDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}
